import { pages } from "@/services/requests";
import { useMutation } from "react-query";

function useOrderStock() {
  const {
    data,
    mutate: mutateOrderStock,
    isLoading: isLoadingOrderStock,
  } = useMutation(
    (params: { product_id: number; name: string; phone: string }) =>
      pages.postOrderNoStock(params)
  );

  return {
    data,
    mutateOrderStock,
    isLoadingOrderStock,
  };
}

export default useOrderStock;
